module.exports = __webpack_public_path__ + "cat-fill.jpg?0cfc125a4975c6828460ffb540eeafbc";